import React from 'react';
import PropTypes from 'prop-types';

const Beneficiaries = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.67 13.13C17.3553 13.5239 17.9288 14.0859 18.3365 14.7631C18.7442 15.4402 18.9726 16.2101 19 17V20H22C22.2652 20 22.5196 19.8946 22.7071 19.7071C22.8947 19.5196 23 19.2652 23 19V17C23 14.82 19.43 13.53 16.67 13.13Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M15 12C16.0609 12 17.0783 11.5786 17.8284 10.8284C18.5786 10.0783 19 9.06087 19 8C19 6.93913 18.5786 5.92172 17.8284 5.17157C17.0783 4.42143 16.0609 4 15 4C14.5466 4.00733 14.0974 4.08839 13.67 4.24C14.5271 5.30578 14.9943 6.63237 14.9943 8C14.9943 9.36763 14.5271 10.6942 13.67 11.76C14.0974 11.9116 14.5466 11.9927 15 12Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M9 12C9.79113 12 10.5645 11.7654 11.2223 11.3259C11.8801 10.8864 12.3928 10.2616 12.6955 9.53074C12.9983 8.79983 13.0775 7.99556 12.9231 7.21964C12.7688 6.44372 12.3878 5.73098 11.8284 5.17157C11.269 4.61216 10.5563 4.2312 9.78036 4.07686C9.00444 3.92252 8.20017 4.00173 7.46927 4.30448C6.73836 4.60723 6.11365 5.11992 5.67412 5.77772C5.2346 6.43552 5 7.20888 5 8C5 9.06087 5.42143 10.0783 6.17157 10.8284C6.92172 11.5786 7.93913 12 9 12ZM9 6C9.39556 6 9.78224 6.1173 10.1111 6.33706C10.44 6.55683 10.6964 6.86918 10.8478 7.23463C10.9991 7.60009 11.0387 8.00222 10.9616 8.39018C10.8844 8.77814 10.6939 9.13451 10.4142 9.41422C10.1345 9.69392 9.77814 9.8844 9.39018 9.96157C9.00222 10.0387 8.60009 9.99914 8.23463 9.84776C7.86918 9.69639 7.55682 9.44004 7.33706 9.11114C7.1173 8.78224 7 8.39556 7 8C7 7.46957 7.21071 6.96086 7.58579 6.58579C7.96086 6.21072 8.46957 6 9 6Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M9 13C6.33 13 1 14.34 1 17V19C1 19.2652 1.10536 19.5196 1.29289 19.7071C1.48043 19.8946 1.73478 20 2 20H16C16.2652 20 16.5196 19.8946 16.7071 19.7071C16.8946 19.5196 17 19.2652 17 19V17C17 14.34 11.67 13 9 13ZM15 18H3V17C3.2 16.28 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

Beneficiaries.propTypes = {
  fill: PropTypes.string,
};

export default Beneficiaries;
